<template>
  <div class="Studentscomment" v-cloak>
    <div class="box">
      <h5 class="isintroduced">学员评论</h5>
      <h5 class="box-nav-sentiment">
        评论( <span style="color: #4ccaff">{{ itemsa.plcyrs }}</span> 人参与,
        <span style="color: #4ccaff">{{ comments }}</span
        >评论 )
      </h5>
      <el-input
        type="textarea"
        :autosize="{ minRows: 2 }"
        placeholder="请输入内容"
        v-model="textarea"
        class="taxt"
      >
      </el-input>
      <el-button class="botton" type="primary" @click="Comments(textarea)"
        >发表评论</el-button
      >
      <div class="box-content" v-for="(item, index) in txstthis" :key="index">
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <div style="display: flex; align-items: center">
            <img
              style="width: 45px; height: 45px"
              :src="http + item.nickname"
              alt=""
            />
            <h5
              class="box-name"
              :style="itemPhone == item.userid ? 'color:#4CCAFF' : ''"
            >
              {{ item.name }} :
            </h5>
          </div>
          <div style="color: #999999">{{ item.letime }}</div>
        </div>
        <p class="box-conten">{{ item.leaves }}</p>
        <div class="box-time">
          <span
            v-if="item.userid === $store.state.user.phone"
            style="color: red; cursor: pointer"
            @click="setTimeoutis(item.id)"
            >删除</span
          >

          <span
            style="cursor: pointer"
            v-if="fromsd[index].ssss == true"
            @click="(fromsd[index].ssss = false), selleavesis()"
            >收起</span
          >
          <span
            style="cursor: pointer"
            @click="selhfleavesid(item, index), (page1s.pager = 1)"
            >回复 ({{ item.hfrs }})</span
          >
        </div>
        <div class="fromgs" v-if="fromsd[index].ssss">
          <div
            v-for="(itas, indent) in txstthis[index].qtwyzd"
            :key="indent"
            class="box-fromgs"
          >
            <div class="commentsx">
              <h5 :style="itemPhone == itas.userids ? 'color:#4CCAFF' : ''">
                {{ itas.names }} :
              </h5>
              <span v-if="itas.name"> &nbsp; &nbsp; 回复 &nbsp; &nbsp; </span>
              <h5 :style="itemPhone == itas.userid ? 'color:#4CCAFF' : ''">
                {{ itas.name }} :
              </h5>
              <p>{{ itas.leaves }}</p>
            </div>
            <span class="spanties" style="color: #999">
              {{ itas.letime }}
            </span>
            <span
              v-if="itas.userids === $store.state.user.phone"
              style="cursor: pointer"
              class="Chh"
              @click="delhfleavesis(itas, item, index)"
              >删除</span
            >
            <span @click="itthuiszz(itas)" class="spantiessss">回复</span>
          </div>
          <div class="fyqs">
            <el-pagination
              v-if="page1s.totals > 5"
              class="pagerss"
              background
              prev-text="上一页"
              next-text="下一页"
              @current-change="(val) => handleCurrentChangess(item, index, val)"
              :page-size="page1s.rows"
              layout="prev, pager, next"
              :total="page1s.totals"
            >
            </el-pagination>
          </div>
          <div class="reply" v-if="itthuis">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2 }"
              placeholder="请输入内容"
              v-model="sdsss"
              class="taxts"
            >
            </el-input>
            <el-button @click="inshfleavesis(item, index, xinss)" type="primary"
              >回复</el-button
            >
          </div>

          <div class="reply" v-if="itthuissds">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2 }"
              placeholder="请输入内容"
              v-model="sdsss"
              class="taxts"
            >
            </el-input>
            <el-button @click="inshfleavesiss(item, index)" type="primary"
              >回复</el-button
            >
          </div>
        </div>
      </div>
      <!-- <div
        style="
          border-top: 1px solid #ddd;
          width: 600px;
          padding: 12.5px 0 12.5px 0;
          margin-left: 15px;
        "
      ></div> -->
    </div>
    <el-pagination
      class="pager"
      background
      prev-text="上一页"
      next-text="下一页"
      @current-change="handleCurrentChange"
      layout="prev, pager, next"
      :total="page1.total"
    >
    </el-pagination>
  </div>
</template>
<script>
import {
  selremark,
  delremark,
  insremark,
  insremarkhf,
  selremarkhf,
  delremarkhf,
} from "../../../api/patient";
// import Bus from '@/utils/bus'
export default {
  data() {
    return {
      http: this.$store.state.https,
      itthuissds: true,
      itthuis: false,
      page1: {
        total: 1000,
        pager: 1,
        rows: 10,
      },
      page1s: {
        totals: 1000,
        pager: 1,
        rows: 5,
      },
      fromsd: [
        { ssss: false },
        { ssss: false },
        { ssss: false },
        { ssss: false },
        { ssss: false },
        { ssss: false },
        { ssss: false },
        { ssss: false },
        { ssss: false },
        { ssss: false },
      ],
      noder: [
        { ssss: false },
        { ssss: false },
        { ssss: false },
        { ssss: false },
        { ssss: false },
        { ssss: false },
        { ssss: false },
        { ssss: false },
        { ssss: false },
        { ssss: false },
      ],
      comments: "",
      answering: [],
      sdsss: "",
      txstthis: [],
      textarea: "",
      itemsa: {
        gm: "",
        id: this.$store.state.Jumpid,
        itemtime: "",
        jg: "",
        jsjs: "",
        kcjs: "",
        ll: "",
        name: "",
        pf: "",
        plcyrs: "",
        plts: "",
        rjxz: {
          bhrjbb: [],
          id: "",
          rjjj: "",
          rjlb: "",
          rjmc: "",
          rjsm: "",
          rjsm1: "",
          rjsp: "",
          rjsp1: "",
          rjtb: "",
          rjtb1: "",
          softwaretime: "",
        },
        sc: "",
        scrq: "",
        softwareid: "",
        sort: "",
        sp: "",
        sp1: "",
        status: "",
        tsy: "",
        userid: "",
        xj: "",
      },
      ssss: false,
      xinss: "",
      tsy: 60,
      psdsa: 0,
      difal: [
        { difsddd: false },
        { difsddd: false },
        { difsddd: false },
        { difsddd: false },
        { difsddd: false },
      ],
    };
  },
  created() {},
  mounted() {
    this.itemPhone = this.$store.state.kpwzxx.phone;
    // Bus.$emit('activeIndexss', '/Studentscomment')
    this.selitemid();
    this.selleavesis();
  },
  methods: {
    //  删除楼主评论
    setTimeoutis(item) {
      var data = new FormData();
      data.append("id", item);
      delremark(data).then((res) => {
        if (res.code === "OK") {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "success",
          });
          this.selleavesis();
        }
      });
    },
    // 撤回
    delhfleavesis(i, item, index) {
      var data = new FormData();
      data.append("id", i.id);
      delremarkhf(data).then((res) => {
        if (res.code === "OK") {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "success",
          });
          // this.selitemid()
          this.selhfleavesid(item, index);
        }
      });
    },
    // 回复之前
    itthuiszz(item) {
      this.itthuis = true;
      this.itthuissds = false;
      this.sdsss = item.names + ":";
      this.xinss = item;
    },
    // 我也说一句
    wysuju(item, i) {},
    // 分页
    handleCurrentChangess(item, i, val) {
      this.page1s.pager = val;
      this.selhfleavesid(item, i);
    },
    // 分页
    handleCurrentChange(val) {
      this.page1.pager = val;
      this.selleavesis();
    },
    // 回复按钮
    inshfleavesis(item, i, s) {
      if (this.$store.state.isLogin) {
        this.sdsss = this.sdsss.split(":");
        console.log(this.sdsss);
        if (this.sdsss.length === 1) {
          this.sdsss = this.sdsss[0];
          this.inshfleavesiss(item, i);
        } else {
          if (this.sdsss !== "") {
            this.sdsss = this.sdsss[1];
            var data = new FormData();
            data.append("userids", this.$store.state.user.phone);
            data.append("userid", this.xinss.userids);
            data.append("leaves", this.sdsss);
            data.append("oneid", item.id);
            insremarkhf(data).then((res) => {
              if (res.code === "OK") {
                this.$message({
                  showClose: true,
                  message: res.msg,
                  type: "success",
                });
                this.sdsss = "";
                // this.setTimeoutis()
                this.selhfleavesid(item, i);
              }
            });
          } else {
            this.$message({
              showClose: true,
              message: "请输入回复内容",
              type: "warning",
            });
          }
        }
      } else {
        this.$message({
          showClose: true,
          message: "请先进行登录",
          type: "warning",
        });
      }
    },

    // 回复按钮
    inshfleavesiss(item, i) {
      if (this.$store.state.isLogin) {
        if (this.sdsss !== "") {
          var data = new FormData();
          data.append("userid", item.userid);
          data.append("userids", this.$store.state.user.phone);
          data.append("leaves", this.sdsss);
          data.append("oneid", item.id);
          insremarkhf(data).then((res) => {
            if (res.code === "OK") {
              this.$message({
                showClose: true,
                message: res.msg,
                type: "success",
              });
              this.sdsss = "";
              // this.setTimeoutis()
              this.selhfleavesid(item, i);
            }
          });
        } else {
          this.$message({
            showClose: true,
            message: "请输入回复内容",
            type: "warning",
          });
        }
      } else {
        this.$message({
          showClose: true,
          message: "请先进行登录",
          type: "warning",
        });
      }
    },
    // 获取回复列表
    selhfleavesid(item, i) {
      var data = new FormData();
      data.append("oneid", item.id);
      data.append("page", this.page1s.pager);
      data.append("rows", this.page1s.rows);
      data.append("phone", item.userid);
      selremarkhf(data).then((res) => {
        this.txstthis[i].qtwyzd = res.records;
        this.page1s.totals = res.totalCount;

        for (var s = 0; s < this.txstthis[i].qtwyzd.length; s++) {
          this.txstthis[i].qtwyzd[s].thesa = false;
        }

        for (let i = 0; i < this.fromsd.length; i++) {
          this.fromsd[i].ssss = false;
        }
        this.fromsd[i].ssss = true;
      });
      this.itthuissds = true;
      this.itthuis = false;
      this.sdsss = "";
    },
    // 评论列表
    selleavesis() {
      var data = new FormData();
      data.append("knowid", this.$store.state.Jumpid);
      data.append("phone", this.itemPhone);
      data.append("page", this.page1.pager);
      data.append("rows", this.page1.rows);
      selremark(data).then((res) => {
        this.txstthis = res.records;
        this.comments = res.totalCount;
        this.page1.total = res.totalCount;
        for (let i = 0; i < this.txstthis.length; i++) {
          this.txstthis[i].ssss = false;
        }
      });
    },

    // 发布评价
    Comments(item) {
      if (this.$store.state.isLogin) {
        if (item !== "") {
          var data = new FormData();
          data.append("userid", this.$store.state.user.phone);
          data.append("leaves", item);
          data.append("knowid", this.$store.state.Jumpid);
          insremark(data).then((res) => {
            if (res.code === "OK") {
              this.$message({
                showClose: true,
                message: res.msg,
                type: "success",
              });
              this.selleavesis();
              this.textarea = "";
            }
          });
        } else {
          this.$message({
            showClose: true,
            message: "请输入评论内容",
            type: "warning",
          });
        }
      } else {
        this.$message({
          showClose: true,
          message: "请先进行登录",
          type: "warning",
        });
      }
    },
    // 获取父组件传递过来的内容/
    selitemid() {
      var a = sessionStorage.itemss;
      this.itemsa = JSON.parse(a);
    },
  },
};
</script>
<style scoped lang="scss">
.Studentscomment {
  width: 100%;
  .box {
    margin: 0 auto;
    width: 687px;
    min-height: 500px;
    display: flex;
    text-align: left;
    flex-direction: column;
  }
}
.taxt {
  width: 600px;
  // height: 60px;
  margin-left: 15px;
}
.isintroduced {
  margin-top: 25px;
  margin-bottom: 19px;
  // width: 56px;
  text-align: left;
  padding-left: 10px;
  border-left: 2px solid #4ccaff;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #333333;
}
.box-nav-sentiment {
  margin-top: 28px;
  margin-bottom: 10px;
  margin-left: 15px;
}
.botton {
  width: 60px;
  height: 25px;
  padding: 0px;
  font-size: 12px;
  margin-top: 10px;
  margin-left: 550px;
  margin-bottom: 10px;
}
.box-content {
  margin-left: 15px;
  border-top: 1px solid #ddd;
  width: 600px;
  min-height: 60px;
  padding: 12.5px 0 12.5px 0;
  .box-name {
    font-family: Source Han Sans CN;
    font-weight: bold;
    font-size: 14px;
    color: #333333;
  }
  .box-conten {
    width: 540px;
    margin-top: 10px;
    margin-left: 30px;
    text-indent: 2rem;
  }
  .box-time {
    text-align: right;
    margin-left: 400px;
    margin-top: 6px;
    // display: flex;
    span {
      color: #4ccaff;
      margin-left: 20px;
    }
  }
}
.taxts {
  width: 550px;
  margin-top: 20px;
}
.commentsx {
  margin-top: 12px;
  display: flex;
  margin-bottom: 13px;
  h5 {
    color: #333333;
  }
}
.fromgs {
  margin-top: 15px;
  border: 1px solid #ddd;
  padding-left: 25px;
  padding-right: 25px;
}
.reply {
  button {
    margin-top: 20px;
    margin-left: 480px;
    width: 60px;
    height: 30px;
    padding: 0px;
    margin-bottom: 20px;
  }
}
.box-fromgs {
  height: 55px;
  border-bottom: 1px solid #ddd;
}
.spanties {
  margin-left: 330px;
}
.pager {
  margin-top: 20px;
  text-align: center;
}
.Chh {
  margin-left: 10px;
  color: red;
  margin-right: 10px;
}
.fyqs {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  button {
    padding: 0px;
    font-size: 12px;
    padding-left: 20px;
    padding-right: 20px;
    height: 30px;
  }
}
.spantiessss {
  cursor: pointer; //鼠标悬浮变"手",
  color: #4ccaff;
}
.el-pagination {
  ::v-deep span {
    padding: 0 10px;
  }
}

// 适配手机端
@media (max-width: 768px) {
  .Studentscomment {
    width: 100%;
    .box {
      width: 95vw;
    }
  }
  .taxt {
    width: 90vw;
  }
  .isintroduced {
    margin-top: 25px;
    margin-bottom: 19px;
    // width: 56px;
    text-align: left;
    padding-left: 10px;
    border-left: 2px solid #4ccaff;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #333333;
  }
  .box-nav-sentiment {
    margin-top: 28px;
    margin-bottom: 10px;
    margin-left: 15px;
  }
  .botton {
    margin-left: 70vw;
  }
  .box-content {
    margin-left: 15px;
    border-top: 1px solid #ddd;
    width: 90vw;
    min-height: 60px;
    padding: 10px 0 10px 0;
    .box-name {
      font-family: Source Han Sans CN;
      font-weight: bold;
      font-size: 14px;
      color: #333333;
    }
    .box-conten {
      width: 40px;
      margin-top: 10px;
      margin-left: 30px;
      text-indent: 2rem;
    }
    .box-time {
      text-align: right;
      margin-left: 40px;
      margin-top: 6px;
      // display: flex;
      span {
        color: #4ccaff;
        margin-left: 20px;
      }
    }
  }
  .taxts {
    width: 80vw;
    margin-top: 20px;
  }
  .commentsx {
    margin-top: 12px;
    display: flex;
    margin-bottom: 13px;
    h5 {
      color: #333333;
    }
  }
  .fromgs {
    margin-top: 15px;
    border: 1px solid #ddd;
    padding-left: 25px;
    padding-right: 25px;
  }
  .reply {
    button {
      margin-top: 20px;
      margin-left: 60vw;
      width: 60px;
      height: 30px;
      padding: 0px;
      margin-bottom: 20px;
    }
  }
  .box-fromgs {
    height: 55px;
    border-bottom: 1px solid #ddd;
  }
  .spanties {
    margin-left: 20vw;
  }
  .pager {
    margin-top: 20px;
    text-align: center;
  }
  .Chh {
    margin-left: 10px;
    color: red;
    margin-right: 10px;
  }
  .fyqs {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    button {
      padding: 0px;
      font-size: 12px;
      padding-left: 20px;
      padding-right: 20px;
      height: 30px;
    }
  }
  .spantiessss {
    cursor: pointer; //鼠标悬浮变"手",
    color: #4ccaff;
  }
  .el-pagination {
    ::v-deep span {
      padding: 0 10px;
    }
  }
}
</style>
